import './DocumentActions.scss';
import '../DocumentStatuses.scss';

import React, { FC } from 'react';
import { DocumentStatusKey } from 'models/DocumentStatusKey';
import moment from 'moment';
import { Col, Dropdown, Row } from 'react-bootstrap';

const STATUS_MAP: Record<DocumentStatusKey, number> = {
  [DocumentStatusKey.PLANNED]: 1,
  [DocumentStatusKey.PENDING_CONTENT]: 2,
  [DocumentStatusKey.PENDING_APPROVAL]: 3,
  [DocumentStatusKey.ACCEPTED]: 7,
  [DocumentStatusKey.REJECTED]: 4,
  [DocumentStatusKey.PREPUBLISHED]: 5,
  [DocumentStatusKey.PUBLISHED]: 6,
  [DocumentStatusKey.ERROR]: 8,
};

interface DocumentActionsProps {
  statusId: number;
  onSave: (publishNow: boolean, overrideStatusKey: DocumentStatusKey | undefined) => void;
  onDelete?: () => void;
  scheduleDate?: Date;
}

const DocumentActions: FC<DocumentActionsProps> = ({
  statusId,
  onSave,
  onDelete,
  scheduleDate,
}) => {
  const currentKey =
    (Object.entries(STATUS_MAP).find(([, id]) => id === statusId)?.[0] as DocumentStatusKey) ??
    DocumentStatusKey.PLANNED;

  const label = currentKey
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (l) => l.toUpperCase());

  return (
    <Row className="fixed-bottom approval-bar">
      <Col md={12} className="py-2">
        <div className="d-flex align-items-center justify-content-between gap-3">
          <div className="ml-2 text-muted small xs-display-none">
            <i className={`bi ${scheduleDate ? "bi-calendar-check" : "bi-calendar-x"} me-2`} />
            {scheduleDate ? `Scheduled on ${moment(scheduleDate).format("MMMM D, YYYY")} at ${moment(scheduleDate).format("h:mm A")}` : "Not scheduled yet"}
          </div>

          <div className="d-flex align-items-center gap-2">
            <Dropdown drop="down" align="end" className='ddl-status'>
              <Dropdown.Toggle
                className="btn btn-light rounded-pill px-3 d-flex align-items-center dropdown-toggle"
                title="Change document status"
              >
                <span className={`status-dot me-2 bg-${currentKey}`} />
                <span className="fw-semibold">{label}</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdown-menu-end shadow-sm py-1" style={{ minWidth: 220 }}>
                {Object.entries(STATUS_MAP).map(([key, id]) => {
                  const active = id === statusId;
                  const displayName = key
                    .replace(/_/g, " ")
                    .toLowerCase()
                    .replace(/\b\w/g, (l) => l.toUpperCase());

                  return (
                    <li key={key}>
                      <Dropdown.Item
                        className={`d-flex align-items-center ${active ? "active fw-semibold" : ""
                          }`}
                        onClick={() => onSave(false, key as DocumentStatusKey)}
                      >
                        <span className={`status-dot me-2 bg-${key}`} />
                        <span>{displayName}</span>
                        {active && <i className="bi bi-check-lg ms-auto text-success" />}
                      </Dropdown.Item>
                    </li>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>

            <div className='document-actions'>
              <button
                type="button"
                className="btn btn-outline-primary xs-mb-2 me-2"
                onClick={() => onSave(false, undefined)}
                title="Save draft"
              >
                <i className="bi bi-save me-2" />
                Save
              </button>

              <button
                type="button"
                className="btn btn-primary me-2"
                onClick={() => onSave(true, undefined)}
                title="Publish now"
              >
                <i className="bi bi-cloud-upload me-2" />
                Publish
              </button>

              <button
                type="button"
                className="btn btn-outline-danger xs-display-none"
                onClick={onDelete}
                title="Delete document"
              >
                <i className="bi bi-trash me-2" />
                Delete
              </button>
            </div>

          </div>
        </div>
      </Col>
    </Row>
  );
};


export default DocumentActions;
